import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';

export const cohortCellHeight = 26;
export const cohortCellColumns = 13;
export const cohortCellGapVertical = Utils.Token.ToInt(Spacing, 'stack.nano');
export const cohortCellGapHorizontal = Utils.Token.ToInt(Spacing, 'stack.nano');
